import { type ResourceRef } from '@angular/core';
import { IInfiniteScrollCollectionVm } from '../../models/infinite-scroll-collection.model';

// Maps a plain resource result into the collection VM shape so a simple
// non-paginated resource can be consumed like an infinite-scroll collection.
export function toInfiniteScrollCollectionVm<TItem>(
  resourceRef: ResourceRef<{ items: TItem[]; totalElements: number } | undefined>,
): IInfiniteScrollCollectionVm<TItem> {
  const error = resourceRef.error();

  // On error the result is discarded (empty list/counter) instead of keeping the last one: as in the
  // infinite scroll, this is an accumulated result, not the entity a view is showing. For the latter
  // see `keepLastResolvedValue` (layout-ionic).
  return {
    items: error ? [] : (resourceRef.value()?.items ?? []),
    totalElements: error ? 0 : (resourceRef.value()?.totalElements ?? 0),
    isLoading: resourceRef.isLoading(),
    isLoadingMore: false,
    error: error as Error | undefined,
    hasMore: false,
    hasLoadedMore: false,
    isStale: false,
    lastLoadedAt: null,
    staleSince: null,
  };
}
